import ArrowRightWhiteSvg from '../../../../images/arrowRightWhite.svg';

const useCardArrowIcon = () => {
	return ArrowRightWhiteSvg;
};

export default useCardArrowIcon;
